<template>
  <div id="container">
    <div class="headerLogin">
      <div>
        <img class="img" src="../../../static/image/login/logo.png" alt="" />
        <span class="span">忘记密码</span>
      </div>
    </div>
    <div class="content">
      <div class="contentUser">
        <div class="contentLeft">
          <img class="img" src="../../../static/image/login/loginimg.png" alt="">
        </div>
        <div class="contentRight">
          <div class="userlogin">忘记密码</div>
          <div class="information">
            <div class="topone">
              <span class="leftCode">手机号</span>
              <input class="nameInput" maxlength="11" placeholder="请输入手机号" v-model="phoneNum">
              <button class="yzbuton" v-if="codeSuccess">{{timeCount}}s后重新发</button>
              <button class="yzbuton" @click="getCode" v-else>发送验证码</button>
            </div>
            <div class="line"></div>
            <div>
              <span class="leftCode">验证码</span>
              <input class="wordInput" type="text" placeholder="请输入验证码" maxlength="6" v-model="codeNum">
            </div>
            <div class="line"></div>
            <div>
              <span class="leftCode">新密码</span>
              <input class="wordInput" type="password" placeholder="请输入密码" v-model="PWNum">
            </div>
            <div class="line"></div>
            <div>
              <span class="leftCode">确认密码</span>
              <input class="wordInput" type="password" placeholder="请确认密码" v-model="PWNumAgain">
            </div>
            <div class="line"></div>
            <button class="saveBtn" @click="savePassword">保存</button>
            <div @click="goLogin" style="font-size: 12px;text-align: center;margin-top:10px;"><span>账号登录</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'forgetPassword',
    data() {
      return {
        phoneNum: "",
        codeNum: "",
        PWNum: "",
        PWNumAgain: "",
        userName: '',
        password: '',
        codeLogin: false,
        passwordLogin: false,
        codeSuccess: false,
        timeCount: 60,
      }
    },
    methods: {
      goLogin(){
        this.$router.push({path: '/login/login'})
      },
      //发送验证码
      async getCode() {
        if (!this.phoneNum || this.codeSuccess) {
          return false;
        }
        if (!(/^1[3|4|5|8|7|6|9][0-9]\d{8}$/.test(this.phoneNum))) {
          this.$message('请输入正确手机号码');
          return false;
        }
        let data = {
          phone: this.phoneNum,
          smsMode: 3
        }
        try {
          const res = await this.$http.designerSms(data)
          console.log(res)
          if (res.code == 200) {
            this.codeSuccess = true;
            this.timeCount = 60;
            let timer = setInterval(() => {
              if (this.timeCount <= 0) {
                clearInterval(timer);
                this.codeSuccess = true;
                this.timeCount = 60;
              } else {
                this.timeCount--;
              }
            }, 1000)
          } else {
            this.$message(res.message);
          }
        } catch (e) {
          throw e
        }
      },
      async savePassword() {
        if (!this.phoneNum || !this.codeNum || !this.PWNum || !this.PWNumAgain) {
          return false;
        }
        if (!/^[a-zA-Z0-9]{8,8}$/.test(this.PWNum)) {
          this.$message('密码请输入8位数字或字母');
          return false;
        }
        if (this.PWNum != this.PWNumAgain) {
          this.$message('两次输入的密码不一致');
          return false;
        }
        try {
          let data = {
            phone: this.phoneNum,
            captcha: this.codeNum,
            newPassword1: this.PWNum,
            newPassword2: this.PWNumAgain
          }
          const res = await this.$http.changePassword(data)
          if (res.code == 200) {
            this.$message({
              message: '密码修改成功',
              type: 'success'
            });
            setTimeout(() => {
              this.$router.push({
                path: '/login/login'
              })
            }, 1000)
          } else {
            this.$message(res.message);
          }
        } catch (e) {
          throw e
        }
      },
      codeLoginClick() {
        this.codeLogin = true
        this.passwordLogin = true
      },
      register() {
        this.$router.push({
          name: 'register'
        })
        console.log('llll')
      },
      forgetPassword() {
        console.log('oooo')
      },
      login() {
        console.log('login')
      },
      messageCode() {
        this.$router.push({
          name: 'loginNumber'
        })
        console.log('messageCode')
      }
    }
  }
</script>

<style lang='less' scoped>
  .headerLogin {
    width: 100%;
    height: 118px;

    .img {
      margin-left: 379px;
      margin-top: 24px;
    }

    .span {
      position: relative;
      top: -12px;
      margin-left: 27px;
      width: 104px;
      height: 30px;
      font-size: 25px;
      font-weight: 500;
      color: #333333;
      cursor: pointer;
    }
  }

  .content {
    width: 100%;
    height: 784px;
    background-image: url('../../../static/image/login/back.png') !important;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    // background: red;
    display: flex;
    justify-content: center;
  }

  .contentUser {
    display: inline-block;
    width: 777px;
    height: 486px;
    margin-top: 126px;
    /* margin-left: 572px; */

    .contentLeft {
      float: left;
      width: 361px;
      height: 486px;

      .img {
       width: 361px;
       height: 486px;
      }
    }

    .contentRight {
      background-color: #FFFFFF;
      float: right;
      width: 416px;
      height: 486px;

      .saveBtn {
        width: 230px;
        height: 39px;
        color: #fff;
        font-size: 15px;
        border-radius: 20px;
        background-color: #DFB876;
        margin-left:81px;
        margin-top: 60px;
        border: none;
        outline: none;
      }

      .userlogin {
        margin-left: 144px;
        margin-top: 41px;
        width: 104px;
        height: 36px;
        font-size: 25px;
        font-weight: bold;
        line-height: 31px;
        color: #3A3A3A;
      }

      .information {
        .topone {
          margin-top: 34px;
        }

        .leftCode {
          margin-left: 48px;
          color: #3A3A3A;
          font-size: 14px;
        }

        .line {
          height: 2px;
       width: 345px;
          border-bottom: 1px solid #f2f6fc;
          margin-left: 34px;
          margin-top: 10px;
        }

        .yzbuton {
          position: relative;
          display: inline;
          width: 90px;
          height: 26px;
          background: #FFFFFF;
          border: 1px solid #DFB876;
          font-size: 12px;
          margin-left: -10px;
          color: #DFB876;
          border-radius: 5px;
          outline: none;
        }

        .nameInput {
          border: none;
          height: 20px;
          color: #c7c7c7;
          font-size: 13px;
        }

        .nameInput:focus {
          border: none;
          outline: none;
        }

        .wordInput {
          margin-top: 10px;
          border: none;
          height: 20px;
        }

        .wordInput:focus {
          border: none;
          outline: none;
        }

        .btn {
          .buttons {
            width: 268px;
            height: 48px;
            border-radius: 20px;
            margin-left: 81px;
            margin-top: 24px;
          }
        }

        .code {
          margin-left: 152px;
          margin-top: 12px;
        }
      }
    }
  }

  input:-internal-autofill-selected {
    -webkit-text-fill-color: #303133 !important;
    transition: background-color 5000s ease-in-out 0s !important;
  }

  span {
    width: 70px;
    display: inline-block;
    text-align: justify;
  }
</style>



// WEBPACK FOOTER //
// src/pages/login/forgetPassword.vue